var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[_c('router-link',{attrs:{"to":_vm.path}},[_c('div',{staticClass:"arrow",staticStyle:{"text-align":"center","line-height":"1"}},[_vm._v("⌃")]),_c('img',{attrs:{"src":_vm.image}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }